import ping from '@databases/ping-registry';

import { PresenceState } from './presence-state.ts';

export const presenceState = new PresenceState(ping);
